import React from 'react';
import Tier1Provider from './Tier1Provider';

const Tier1ProviderGrid = ({ providers, providerSelect }) => (
    <ul className="watchProvider__list-items--is-premier">
        {providers.map((provider) => (
            <Tier1Provider key={`tier1provider${provider.name}`} provider={provider} providerSelect={providerSelect} />
        ))}
    </ul>
);

Tier1ProviderGrid.propTypes = {
    providers: React.PropTypes.array,
    providerSelect: React.PropTypes.func
};

export default Tier1ProviderGrid;



// WEBPACK FOOTER //
// ./app/modal/authn/Tier1ProviderGrid.js